import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AccesoService } from '../acceso/acceso.service';
import { map, filter, pluck } from 'rxjs/operators';
import { Observable  } from "rxjs";
import { SessionStorageService } from '../storage/sessionStorage.service';
import { LocalService } from '../storage/localService';

@Injectable({
  providedIn: 'root'
})
export class FirmaElectronicaService {

  readonly urlBase =  environment.rutaBase;
  //readonly urlBase =  "http://localhost:2529/api-contrato";

  header: HttpHeaders;
  message: Observable<any>;
  idEmpresa_Factor : any;

  constructor(private http : HttpClient,  private accesoService :AccesoService, private sessionStorageService: SessionStorageService,private localService : LocalService) {
    this.header = this.accesoService.desencriptarTOKEN();  
    this.datoStorage();
  }

  datoStorage(){
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
   this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
   if (this.idEmpresa_Factor == undefined) {
    this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
   } 
  }

  enviarContratoElectronico(body :any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/KeynuaEnviarContrato?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  enviarContratoMarcoElectronico(body :any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/KeynuaEnviarContratoMarco?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers}).pipe( map ( (data) => {return data;}))
  }

  enviarPagareElectronico(body :any){
  let headers = this.header;
  return  this.http.post(`${this.urlBase}/KeynuaEnviarPagare?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers}).pipe( map ( (data) => { return data; }))
  }

  enviarSolicitudDesElectronico(body :any){
  let headers = this.header;
  return  this.http.post(`${this.urlBase}/KeynuaEnviarSolicitudDes?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers}).pipe( map ( (data) => { return data; }))
  }
}
